module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/og-coj_f-4d36032a512cfdeb1ef88e8f814e2e5f.png";